<template>
    <div>
        <agile-bot-button-ad></agile-bot-button-ad>
        <section-border></section-border>
        <div class="flex">


            <div class="container mx-auto max-w-sm w-full p-4 sm:w-1/2">
                <div class="card flex flex-col justify-center p-10 bg-white rounded-lg shadow-2xl">
                    <div class="prod-title">
                        <p class="text-2xl text-center text-gray-900 font-bold mb-4">Planning Poker</p>
                        <p class=" text-md text-gray-400">
                            Plan out story points in a single channel.
                        </p>
                    </div>
                    <div class="flex justify-center mt-3">
                        <img height="200" width="200"
                             src="https://cdn1.iconfinder.com/data/icons/scrum-methodology-1/512/story_point-256.png"
                             class="shadow-lg w-45 h-45  justify-center  bg-white rounded-full object-center "/>
                    </div>
                    <section-border></section-border>
                    <div class="flex justify-center">
                        <button
                            class="focus:outline-none rounded-full bg-white hover:bg-blue-100 text-black border-2 mt-2 mr-2 py-2 px-4  font-bold rounded">
                            How it works?
                        </button>
                    </div>
                    <div class="flex">
                        <div>
                            <button
                                class="text-sm  focus:outline-none rounded-full bg-white hover:bg-blue-100 text-black mt-2 mr-2 py-2 px-4  font-bold rounded">
                                Privacy
                            </button>
                        </div>

                        <div>
                            <button
                                class="text-sm ml-20 focus:outline-none rounded-full bg-white hover:bg-blue-100 text-black mt-2 mr-2 py-2 px-4  font-bold rounded">
                                Usage
                            </button>
                        </div>
                    </div>
                </div>
            </div>


            <div class="container mx-auto max-w-sm w-full p-4 sm:w-1/2">
                <div class="card flex flex-col justify-center p-10 bg-white rounded-lg shadow-2xl">
                    <div class="prod-title">
                        <p class="text-2xl text-center text-gray-900 font-bold mb-4">Retrospective</p>
                        <p class=" text-md text-gray-400">
                            Review and improve your team performance.
                        </p>
                    </div>
<!--                    <div class="flex justify-center mt-3">-->
<!--                        <img src="https://agilesuite.io/img/read-me.png" height="200" width="200"-->
<!--                             class="shadow-lg w-45 h-45  justify-center  bg-white rounded-full object-center "/>-->
<!--                    </div>-->
                    <section-border></section-border>
                    <div class="flex justify-center">
                        <button
                            class="focus:outline-none rounded-full bg-white hover:bg-blue-100 text-black border-2 mt-2 mr-2 py-2 px-4  font-bold rounded">
                            How it works?
                        </button>
                    </div>
                    <div class="flex">
                        <div>
                            <button
                                class="text-sm  focus:outline-none rounded-full bg-white hover:bg-blue-100 text-black mt-2 mr-2 py-2 px-4  font-bold rounded">
                                Privacy
                            </button>
                        </div>

                        <div>
                            <button
                                class="text-sm ml-20 focus:outline-none rounded-full bg-white hover:bg-blue-100 text-black mt-2 mr-2 py-2 px-4  font-bold rounded">
                                Usage
                            </button>
                        </div>
                    </div>
                </div>
            </div>


            <div class="container mx-auto max-w-sm w-full p-4 sm:w-1/2">
                <div class="card flex flex-col justify-center p-10 bg-white rounded-lg shadow-2xl">
                    <div class="prod-title">
                        <p class="text-2xl text-center  text-gray-900 font-bold mb-4">Stand-Up</p>
                        <p class=" text-md text-gray-400">
                            Catchup with team members with a better morning routine.
                        </p>
                    </div>
<!--                    <div class="flex justify-center mt-3">-->
<!--                        <img src="https://agilesuite.io/img/office-kit.png" height="200" width="200"-->
<!--                             class="shadow-lg w-45 h-45  justify-center  bg-white rounded-full object-center "/>-->
<!--                    </div>-->
                    <section-border></section-border>
                    <div class="flex justify-center">
                        <button
                            class="focus:outline-none rounded-full bg-white hover:bg-blue-100 text-black border-2 mt-2 mr-2 py-2 px-4 font-bold rounded">
                            How it works?
                        </button>
                    </div>
                    <div class="flex">
                        <div>
                            <button
                                class="text-sm  focus:outline-none rounded-full bg-white hover:bg-blue-100 text-black mt-2 mr-2 py-2 px-4  font-bold rounded">
                                Privacy
                            </button>
                        </div>

                        <div>
                            <button
                                class="text-sm ml-20 focus:outline-none rounded-full bg-white hover:bg-blue-100 text-black mt-2 mr-2 py-2 px-4  font-bold rounded">
                                Usage
                            </button>
                        </div>
                    </div>
                </div>
            </div>


        </div>

    </div>
</template>

<script>
import Button from "@/Jetstream/Button";
import DialogModal from "@/Jetstream/DialogModal";
import {ref} from 'vue'
import SchedulerSetting from "@/Components/SchedulerSetting/SchedulerSetting";
import QuestionMaker from "@/Components/QuestionMaker/QuestionMaker";
import SecondaryButton from "@/Jetstream/SecondaryButton";
import SectionBorder from "@/Jetstream/SectionBorder";
import AgileBotButtonAd from "@/Pages/SlackBot/AgileBotButtonAd";

export default {
    components: {
        AgileBotButtonAd,
        SectionBorder,
        SecondaryButton,
        QuestionMaker,
        SchedulerSetting,
        DialogModal,
        Button
    },
    methods: {
        submitted(value) {
            console.log('submitted');
            this.items.push(value);
            this.hideModal();
        },
        updated(value) {
            let item = this.items.filter((item) => value.id === item.id)[0];
            let index = this.items.indexOf(item);
            this.$set(this.items, index, value);
            this.hideModal();
        },
        deleted(value) {
            console.log('deleted');
            console.log(value);
            let index = this.items.indexOf(value);
            this.items.splice(index, 1);
        },
        editing(value) {
            console.log('editing');
            this.settingType = 'edit';
            this.selectedItem = value;
            console.log(this.selectedItem);
            this.showModal();
        },
        edited(value) {

        },
        showCreateModal() {
            this.settingType = 'create';
            this.showModal();
        },
        showModal() {
            this.$refs['my-modal'].show()
        },
        hideModal() {
            this.$refs['my-modal'].hide()
        },
        async getItems() {
            let app = this;
            await window.axios.get('/web/apps/agile-bot/report-settings')
                .then(function (response) {
                    app.items = response.data;
                })
                .catch(function (error) {
                    // app.$notify({
                    //     type: 'error',
                    //     group: 'slackit',
                    //     title: 'Auth Error',
                    //     text: 'Your app is unauthorised or uninstalled. Please reinstall it.',
                    //     duration: -1
                    // });
                    // app.$router.push({name: 'my-apps'}, () => {
                    // });
                });
        },
    },
    created() {
        this.getItems();

    },
    setup() {
        const model = ref(null)

        const options = ['vue', 'next', 'select']

        return {
            model,
            options
        }
    },
    data() {
        return {
            channelOptions: [],
            isCreatedReportClicked: false,
            settingType: 'create',
            items: [],
            selectedItem: null,
            form: null,
        }
    }
}
</script>

